import { ArrowLeft, SearchNormal1 } from "iconsax-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../../../utils/token";
import instance from "../../../../../axios/instance";
import { Check } from "lucide-react";
import { toast } from "react-toastify";

export default function RescheduleRequests() {

    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState([])

    async function getHistory() {
        setLoading(true)

        instance.get("/telemedicine/meetings/rejected", {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
            .then(response => {
                console.log(response.data);
                setHistory(response.data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response.data);
                setHistory([])
                setLoading(false)
            })
    }

    async function accept(meetingId, new_start, new_end) {
    instance.post("/telemedicine/doctor/reschedule/accept", {meetingId, new_start, new_end}, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    })
    .then(response => {
      toast.success(response.data.message)
      window.location.reload()
    })
    .catch(error => {
      toast.error(error.response.data.message)
    })
  }

    useEffect(() => {
        getHistory()
    }, [])

    if (loading) {
        return <div />
    }

    return (
        <div className="p-3 space-y-6">
            {/* <div className="font-medium text-[17px]">Account History</div> */}

            <div className="flex items-center gap-2">
                <button onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />
                </button>

                <div className="font-medium text-[17px]">Reschedule requests</div>
            </div>

            <div className="border border-[#20232b22] shadow-sm">

                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead style={{ backgroundColor: '#20232b', color: 'white' }}>
                        <tr>
                            <th style={{ width: '8.33%', padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>#</th>
                            <th style={{ width: '25%', padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Patient name</th>
                            <th style={{ width: '25%', padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Requested schedule</th>
                            <th style={{ width: '33.33%', padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Reason</th>
                            <th style={{ width: '25%', padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.length < 1 ? (
                            <tr>
                                <td colSpan="5" style={{ padding: '12px', color: '#718096' }}>
                                    No recent reschedule requests
                                </td>
                            </tr>
                        ) : (
                            history.map((item, index) => (
                                <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                    <td style={{ padding: '12px' }}>{index + 1}</td>
                                    <td style={{ padding: '12px' }}>{item.patient_name}</td>
                                    <td style={{ padding: '12px' }}>{item.new_schedule}</td>
                                    <td style={{ padding: '12px' }}>{item.reject_message}</td>
                                    <td style={{ padding: '12px' }}>

                                        {
                                            item.doctor_approve === "approved" ? null :
                                            <button
                                            style={{
                                                backgroundColor: 'rgba(0, 177, 172, 0.13)',
                                                color: '#00b1ac',
                                                fontSize: '14px',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                marginTop: 'auto', // Adjust vertical alignment if needed
                                                marginBottom: 'auto',
                                            }}
                                            onClick={() => accept(item.id, item.new_schedule, item.new_schedule_endtime)}
                                        >
                                            Accept
                                            <Check size={16} color="#00b1ac" />
                                        </button>
                                        }
                                        
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                {/* <div className="grid grid-cols-12 gap-3 text-[12px] font-semibold w-full bg-[#20232b] text-white p-3">
                    <div className="col-span-1">#</div>
                    <div className="col-span-3">Patient name</div>
                    <div className="col-span-3">Requested schedule</div>
                    <div className="col-span-4">Reason</div>
                    <div className="col-span-3">#</div>
                </div>

                {
                    history.length < 1 ?
                        <div className="p-3 text-[14px] text-gray-500">No recent reschedule requests</div> :
                        history.map((item, index) => (
                            <div className="grid grid-cols-12 gap-3 text-[14px] w-full border-b p-3">
                                <div className="col-span-1">{index + 1}</div>
                                <div className="col-span-3">{item.patient_name}</div>
                                <div className="col-span-3">{item.new_schedule}</div>
                                <div className="col-span-4">{item.reject_message}</div>
                                <div className="col-span-3">
                                    <button
                                        className="bg-[#00b1ac22] text-[#00b1ac] text-sm rounded-[4px] w-fit px-4 mt-5 py-2 flex items-center gap-2"
                                    //onClick={() => accept(meeting.id, meeting.new_schedule, meeting.new_schedule_endtime)}
                                    >
                                        Accept
                                        <Check size={16} color="#00b1ac" />
                                    </button>

                                </div>
                            </div>
                        ))
                } */}

            </div>
        </div>
    )
}